(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mc-color-swatches"] && !Shopify.designMode) return;
  try {
    class McColorSwatches extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      this.card = this.closest('product-card');
      this.gallery = this.card?.querySelector('.card-gallery');
      this.locked = false;

      this.addEventListener('pointerover', this.#onOver);
      this.addEventListener('pointerleave', this.#onLeave);
      this.addEventListener('click', this.#onClick);
      this.addEventListener('focusin', this.#onOver);
    }

    get #overlay() {
      if (!this.gallery) return null;
      let el = this.gallery.querySelector('.mc-cs__overlay');
      if (!el) {
        el = document.createElement('img');
        el.className = 'mc-cs__overlay';
        el.setAttribute('alt', '');
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('decoding', 'async');
        this.gallery.appendChild(el);
      }
      return el;
    }

    #slideshow() {
      return this.gallery?.querySelector('slideshow-component');
    }

    #preview(button) {
      const overlay = this.#overlay;
      if (!overlay) return;
      const src = button.dataset.large;
      if (!src) return;
      if (overlay.getAttribute('src') !== src) overlay.setAttribute('src', src);
      overlay.classList.add('is-visible');
      this.#slideshow()?.suspend?.();
    }

    #clear() {
      const overlay = this.gallery?.querySelector('.mc-cs__overlay');
      overlay?.classList.remove('is-visible');
      this.#slideshow()?.resume?.();
    }

    #onOver = (event) => {
      const button = event.target.closest?.('.mc-cs__item');
      if (!button || this.locked) return;
      this.#preview(button);
    };

    #onLeave = () => {
      if (this.locked) return;
      this.#clear();
    };

    #onClick = (event) => {
      const button = event.target.closest?.('.mc-cs__item');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();

      this.querySelectorAll('.mc-cs__item').forEach((el) => el.classList.toggle('is-active', el === button));
      this.locked = true;
      this.#preview(button);

      const variantId = button.dataset.variant;
      if (!variantId) return;

      const url = `${this.dataset.productUrl}?variant=${variantId}`;
      const link = this.card?.querySelector('.product-card__link');
      if (link) link.setAttribute('href', url);
      this.card?.querySelector('.card-gallery a[ref="cardGalleryLink"]')?.setAttribute('href', url);

      // Single-option (colour only) products can add straight to cart.
      const input = this.card?.querySelector('quick-add-component input[name="id"]');
      if (input && this.card?.querySelector('quick-add-component')?.dataset.productOptionsCount === '1') {
        input.value = variantId;
        input.removeAttribute('disabled');
      }
    };
  }

  if (!customElements.get('mc-color-swatches')) {
    customElements.define('mc-color-swatches', McColorSwatches);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mc-size-chart"] && !Shopify.designMode) return;
  try {
    class McSizeChart extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      const dialog = this.querySelector('dialog');
      if (!dialog) return;

      this.querySelector('.mc-sc__trigger')?.addEventListener('click', () => dialog.showModal());
      this.querySelector('.mc-sc__close')?.addEventListener('click', () => dialog.close());

      // Clicking the backdrop (i.e. outside the panel) closes the dialog.
      dialog.addEventListener('click', (event) => {
        if (!this.querySelector('.mc-sc__panel')?.contains(/** @type {Node} */ (event.target))) {
          dialog.close();
        }
      });
    }
  }

  if (!customElements.get('mc-size-chart')) {
    customElements.define('mc-size-chart', McSizeChart);
  }
  } catch(e) { console.error(e); }
})();

})();
